export default __webpack_public_path__ + "static/media/grab.1bb05838.cur";